<template>
  <el-card class="box-card" shadow="never">
    <el-form @submit.native.prevent="saveAuth" ref="form" label-position="top" id="form1">
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminateUsers"
        v-model="checkAllUsers"
        @change="handleCheckAllChangeUsers"
        border
        >Marcar todos los usuarios</el-checkbox-button
      >
      <div style="margin: 5px auto">
        <el-select
          size="small"
          class="w-100"
          filterable
          v-model="formUsers"
          multiple
          placeholder="Seleccionar usuarios"
          @change="handleCheckedContentChangeUsers"
        >
          <el-option
            v-for="u in users"
            :key="u.id"
            :value="u.id"
            :label="u.full_name"
          ></el-option>
        </el-select>
      </div>
      <hr />
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminateAreas"
        v-model="checkAllAreas"
        @change="handleCheckAllChangeAreas"
        border
        >Marcar todas las áreas</el-checkbox-button
      >
      <div style="margin: 5px auto">
        <el-select
          size="small"
          class="w-100"
          filterable
          v-model="formAreas"
          multiple
          placeholder="Seleccionar Áreas"
          @change="handleCheckedContentChangeAreas"
        >
          <el-option
            v-for="(c, i) in areas"
            :key="i"
            :value="c.id"
            :label="c.text"
          ></el-option>
        </el-select>
      </div>
      <hr />
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminateDepartamentos"
        v-model="checkAllDepartamentos"
        @change="handleCheckAllChangeDepartamentos"
        border
        >Marcar todos los departamentos</el-checkbox-button
      >
      <div style="margin: 5px auto">
        <el-checkbox-group
          style="display: flex; justify-content: flex-start"
          v-model="formDepartamentos"
          size="small"
          class="flex"
          @change="handleCheckedContentChangeInstalaciones"
        >
          <el-checkbox v-for="(c, i) in departments" :label="c.id" :key="i" border>{{
            c.text
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <hr />
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminateInstalaciones"
        v-model="checkAllInstalaciones"
        @change="handleCheckAllChangeInstalaciones"
        border
        >Marcar todas las instalaciones</el-checkbox-button
      >
      <div style="margin: 5px auto">
        <el-checkbox-group
          v-model="formInstalaciones"
          size="small"
          style="display: flex; justify-content: flex-start"
          class="flex"
          @change="handleCheckedContentChangeInstalaciones"
        >
          <el-checkbox v-for="(c, i) in installations" :label="c.id" :key="i" border>{{
            c.text
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <hr />
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminateCargos"
        v-model="checkAllCargos"
        @change="handleCheckAllChangeCargos"
        border
        >Marcar todos las categorias</el-checkbox-button
      >
      <div style="margin: 20px auto">
        <el-checkbox-group
          style="display: flex; justify-content: flex-start"
          v-model="formCargos"
          size="small"
          class="flex"
          @change="handleCheckedContentChangeCargos"
        >
          <el-checkbox v-for="(c, i) in categories" :label="c.id" :key="i" border>{{
            c.text
          }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <el-checkbox-button
        class="small-checkbox-button"
        :indeterminate="isIndeterminatePuestos"
        v-model="checkAllUsers"
        @change="handleCheckAllChangePuestos"
        border
        >Marcar todos los puestos de trabajo</el-checkbox-button
      >
      <div style="margin: 20px auto">
        <el-select
          class="w-100"
          size="small"
          filterable
          v-model="formPuestos"
          multiple
          placeholder="Seleccionar usuarios"
          @change="handleCheckedContentChangePuestos"
        >
          <el-option
            v-for="u in jobtitles"
            :key="u.id"
            :value="u.id"
            :label="u.text"
          ></el-option>
        </el-select>
      </div>
      <hr />
      <button type="submit" class="el-button el-button--small el-button--primary">
        <span>Guardar Permisos</span>
      </button>
    </el-form>
  </el-card>
</template>
<script>
import ApiService from "@/common/api.service";

const tablas = [
  "users",
  "areas",
  "departments",
  "installations",
  "categories",
  "jobtitles",
];

export default {
  props: ["table", "data"],
  name: "permisos",

  created() {
    if (this.data) {
      this.getValues();
    }
    this.getContent();
  },
  data() {
    return {
      formUsers: [],
      formAreas: [],
      formDepartamentos: [],
      formInstalaciones: [],
      formCargos: [],
      formPuestos: [],
      show: false,
      checkAllUsers: false,
      checkAllAreas: false,
      checkAllDepartamentos: false,
      checkAllInstalaciones: false,
      checkAllCargos: false,
      checkAllPuestos: false,
      isIndeterminateUsers: false,
      isIndeterminateAreas: false,
      isIndeterminateDepartamentos: false,
      isIndeterminateInstalaciones: false,
      isIndeterminateCargos: false,
      isIndeterminatePuestos: false,
      users: [],
      areas: [],
      departments: [],
      installations: [],
      categories: [],
      jobtitles: [],
      values: null,
    };
  },
  methods: {
    async getValues() {
      ApiService.post("dashboard/fecth-desktop-auth", {
        table: this.table + "_auth",
        token: localStorage.getItem("token"),
        project_id: localStorage.getItem("table"),
        id: this.data,
        tableAuth: this.table,
      }).then((response) => {
        this.values = response;
        response.data.users ? (this.formUsers = response.data.users.split(",")) : false;
        response.data.areas ? (this.formAreas = response.data.areas.split(",")) : false;
        response.data.departments
          ? (this.formDepartamentos = response.data.departments.split(","))
          : false;
        response.data.installations
          ? (this.formInstalaciones = response.data.installations.split(","))
          : false;
        response.data.categories
          ? (this.formCargos = response.data.categories.split(","))
          : false;
        response.data.jobtitle
          ? (this.formPuestos = response.data.jobtitle.split(","))
          : false;
      });
    },
    async getContent() {
      tablas.forEach((e) => {
        ApiService.post("dashboard/table", {
          table: e,
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
        }).then((response) => {
          if (e == "users") {
            let user = response.data.filter((e) => {
              if (e.activo == 1) {
                e.full_name = e.last_name + ", " + e.name;
                return e;
              } else {
                return false;
              }
            });

            this.users = user.sort(function (a, b) {
              if (a.full_name < b.full_name) return -1;
              if (a.full_name > b.full_name) return 1;
              return 0;
            });
          } else {
            this[e] = response.data;
          }
        });
      });
      setTimeout(() => {
        this.show = true;
      }, 1000);
    },
    saveAuth() {
      let form = [
        {
          users: this.formUsers.join(),
          areas: this.formAreas.join(),
          departments: this.formDepartamentos.join(),
          installations: this.formInstalaciones.join(),
          categories: this.formCargos.join(),
          jobtitle: this.formPuestos.join(),
        },
      ];

      this.$root.$emit("guardarPermisos", form);

      /* setTimeout(() => {
        ApiService.put("dashboard/update-desktop-auth", {
          table: this.table + "_auth",
          token: localStorage.getItem("token"),
          project_id: localStorage.getItem("table"),
          form: form,
          id: this.data,
          tableAuth: this.table
        }).then(response => {
          if (response.data) {
            this.$message({
              type: "success",
              message: "Permisos actualizados"
            });
          } else {
            this.$message({
              type: "error",
              message: "Algo ha fallado"
            });
          }
          this.$root.$emit("closeModal");
        });
      }, 100); */
    },
    handleCheckAllChangeUsers(val) {
      if (val === true) {
        this.formUsers = this.users.map((c) => {
          return c.id;
        });
      } else {
        this.formUsers = [];
      }
    },
    handleCheckedContentChangeUsers(value) {
      let checkedCount = value.length;
      this.checkAllUsers = checkedCount === this.users.length;
      this.isIndeterminateUsers = checkedCount > 0 && checkedCount < this.users.length;
    },
    handleCheckAllChangeAreas(val) {
      if (val === true) {
        this.formAreas = this.areas.map((c) => {
          return c.id;
        });
      } else {
        this.formAreas = [];
      }
    },
    handleCheckedContentChangeAreas(value) {
      let checkedCount = value.length;
      this.checkAllAreas = checkedCount === this.areas.length;
      this.isIndeterminateAreas = checkedCount > 0 && checkedCount < this.areas.length;
    },
    handleCheckAllChangeDepartamentos(val) {
      if (val === true) {
        this.formDepartamentos = this.departments.map((c) => {
          return c.id;
        });
      } else {
        this.formDepartamentos = [];
      }
    },
    handleCheckedContentChangeDepartamentos(value) {
      let checkedCount = value.length;
      this.checkAllDepartamentos = checkedCount === this.departments.length;
      this.isIndeterminateDepartamentos =
        checkedCount > 0 && checkedCount < this.departments.length;
    },
    handleCheckAllChangeInstalaciones(val) {
      if (val === true) {
        this.formInstalaciones = this.installations.map((c) => {
          return c.id;
        });
      } else {
        this.formInstalaciones = [];
      }
    },
    handleCheckedContentChangeInstalaciones(value) {
      let checkedCount = value.length;
      this.checkAllInstalaciones = checkedCount === this.installations.length;
      this.isIndeterminateInstalaciones =
        checkedCount > 0 && checkedCount < this.installations.length;
    },
    handleCheckAllChangeCargos(val) {
      if (val === true) {
        this.formCargos = this.categories.map((c) => {
          return c.id;
        });
      } else {
        this.formCargos = [];
      }
    },
    handleCheckedContentChangeCargos(value) {
      let checkedCount = value.length;
      this.checkAllCargos = checkedCount === this.categories.length;
      this.isIndeterminateCargos =
        checkedCount > 0 && checkedCount < this.categories.length;
    },
    handleCheckAllChangePuestos(val) {
      if (val === true) {
        this.formPuestos = this.jobtitles.map((c) => {
          return c.id;
        });
      } else {
        this.formPuestos = [];
      }
    },
    handleCheckedContentChangePuestos(value) {
      let checkedCount = value.length;
      this.checkAllPuestos = checkedCount === this.jobtitles.length;
      this.isIndeterminatePuestos =
        checkedCount > 0 && checkedCount < this.jobtitles.length;
    },
  },
};
</script>
<style>
.el-checkbox-button__inner {
  border-left: 1px solid #dcdfe6;
}
.small-checkbox-button .el-checkbox-button__inner {
  padding: 7px;
  background-color: #e6a23c;
  color: #fff;
  border-radius: 4px !important;
  font-weight: 500;
  border:0px;
}
</style>

<style scoped>
.w-100 {
  width: 100%;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
}
.el-checkbox {
  margin-left: 0 !important;
  min-width: 300px !important;
  max-width: 300px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/_commons/auth/addAuth.vue